import { FC } from 'react'

import { useProjectList } from '@/api/models/main'

import UserProfileProject from './UserProfileProject'

const UserProjectsScreen: FC = () => {
  const { dataWithoutParkingPlaces: projectList } = useProjectList()

  return (
    <div className="flex flex-col gap-12 px-40 pb-40 pt-16 lg:gap-8 lg:px-24 lg:pb-20 lg:pt-0 sm:px-16">
      {projectList?.map(project => (
        <UserProfileProject key={project.bc_guid} project={project} />
      ))}
    </div>
  )
}

export default UserProjectsScreen
